module.exports = __webpack_public_path__ + "img/tutorial_ten_nl.bccccf68.png";